import { RawUserPreference, UserPreference } from '@/types/user'

export function mapPreference(preference: RawUserPreference): UserPreference {
  return {
    certificate: preference?.certificate ?? false,
    sort_by: preference?.sort_by ?? 'closing_date',
    sort_order: preference?.sort_order ?? 'desc',
    educational_level: preference?.educational_level ?? [],
    region: preference?.region ?? [],
    universities: preference?.universities?.map((u) => u.university_id) ?? [],
    categories:
      preference?.preference_category?.map((c) => c.category_id) ?? [],
    member_type: preference?.member_type ?? [],
    show_only_active: preference?.show_only_active ?? false,
    closing_date: preference?.closing_date
      ? new Date(preference?.closing_date)
      : null,
    open_date: preference?.open_date ? new Date(preference?.open_date) : null,
    team_number_min: preference?.team_number_min ?? 1,
    team_number_max: preference?.team_number_max ?? 10,
    prize_number_min: preference?.prize_number_min ?? 0,
    prize_number_max: preference?.prize_number_max ?? 100,
    internship: preference?.internship ?? false,
    company_partnership: preference?.company_partnership ?? false,
    publish_work: preference?.publish_work ?? false,
    trophy: preference?.trophy ?? false,
    user_id: preference?.user_id ?? 0,
  }
}
